module.exports = __webpack_public_path__ + "static/img/10.7711efa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/10.png
// module id = CyFt
// module chunks = 0